// extracted by css-extract-rspack-plugin
export default {"mapModalContainer":"mapModalStyles-module__mapModalContainer"};